import {EVENTS_NAME} from '../../config.js'

const {LEAD_TRIGGERED_DETAIL_RESERVATION} = EVENTS_NAME

// INPUT:  event='Lead Triggered', page_name_origin='detail', has_reservation=true,
// lead_type='Detail Ad Replied Email'|'Detail Phone Called'|'Detail Ad Replied Whatsapp'|Financed Purchase Phone Called'|'Financed Purchase Email'
// OUTPUT: ['Lead Triggered Detail Reservation Web']

export const getReservationDetailEvents = ({event, properties}) => {
  const matches =
    event === LEAD_TRIGGERED_DETAIL_RESERVATION.EVENT &&
    properties.page_name_origin === LEAD_TRIGGERED_DETAIL_RESERVATION.PAGE_NAME_ORIGIN &&
    properties.has_reservation &&
    LEAD_TRIGGERED_DETAIL_RESERVATION.LEAD_TYPES.includes(properties.lead_type)

  if (!matches) return []

  return [LEAD_TRIGGERED_DETAIL_RESERVATION.EVENT_OPTIMIZELY]
}
